

/// <reference types="google.maps" />
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import {TranslateService} from '@ngx-translate/core'
import { ReactiveFormsModule, ControlContainer, FormGroupDirective, AbstractControl, FormGroup } from '@angular/forms';
import {  TranslateModule } from '@ngx-translate/core'

@Component({
  selector: 'googlemaps-wrapper',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule ,
       TranslateModule
  ],
  templateUrl: './web-prequal-googlemaps-wrapper.component.html',
   styleUrls: ['../modal-options-form/modal-options-form.component.scss'],
   //styleUrls: ['../web-prequal-form/web-prequal-form.component.scss', './web-prequal-googlemaps-wrapper.component.scss'],
  viewProviders: [
    { provide: ControlContainer, useExisting: FormGroupDirective } // inherit parent formGroup
  ],
  encapsulation: ViewEncapsulation.None
})
export class WebPreQualGoogleMapsWrapperComponent {
  @Input() controlName!: string;            
  @Input() placeholder = 'Address';            
  @Input() addressoptions: any;               
  @Input() dentistSelect: boolean = false             
  @Output() change = new EventEmitter<any>();
  @Output() enterLocationChange = new EventEmitter<any>();
  @Output() blur = new EventEmitter<any>();

   @Input() formGroup!: FormGroup;
  @Output() onAddressChange = new EventEmitter<any>();
  @Output() focusToggleNeighbourMessage = new EventEmitter<any>();
  @Output() focusoutToggleNeighbourMessage = new EventEmitter<any>();
  @Output() inputItemClickEvent = new EventEmitter<any>();


  @ViewChild('autoInput') autoInput!: ElementRef<HTMLInputElement>;

  constructor(private controlContainer: ControlContainer) { }
  get control(): AbstractControl | null {
    return this.controlContainer.control?.get(this.controlName) ?? null;
  }
  async ngOnInit() {
    // Load the "places" library dynamically
    const { Autocomplete } = (await google.maps.importLibrary("places")) as google.maps.PlacesLibrary;
    const autocomplete = new Autocomplete(this.autoInput.nativeElement, {
      types: ['geocode'], 
      componentRestrictions: { country: 'us' } 
    });
    autocomplete.addListener('place_changed', () => {
       const place = autocomplete.getPlace() as any;
        this.onAddressChange.emit(place);
    })


      const control = this.formGroup.get(this.controlName);
      console.log(control?.value);
      control?.setValue(control?.value);


  }
  autoCompleteOnChange(event: any) {
    this.onAddressChange.emit(event);
  }
//   handleChange(event: any) {
//     this.change.emit(event);
//   }
//   handleBlur(event: any) {
//     this.blur.emit(event);
//   }
  enterLocation(event: any) {
    this.enterLocationChange.emit(event);
  }

    toggleNeighbourMessageFocus(event: any) {
        this.focusToggleNeighbourMessage.emit(event);
    }

    toggleNeighbourMessageFocusOut(event: any) {
        this.focusoutToggleNeighbourMessage.emit([event, true]);
    }

    inputItemClick(event: any) {
       this.inputItemClickEvent.emit(event);  

    }
  
}

